export class PaginationHelper {
    static pages(items: any[], pageSize: number): number {
        return Math.ceil(items.length / pageSize);
    }

    static showPagination(items: any[], pageSizeOptions: string[]): boolean {
        return items.length > Number.parseInt(pageSizeOptions[0], 10);
    }

    static canPrevious(currentPage: number): boolean {
        return currentPage > 0;
    }

    static canNext(currentPage: number, pages: number): boolean {
        return currentPage < (pages - 1);
    }
}
